module.exports = __webpack_public_path__ + "img/bv.6ad53928.svg";